var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShareFlat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 9.47351,
    width: 23.3636,
    height: 22.6565,
    fill: "#D4E1F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.814 10.4403L26.9833 17.2483C26.8787 17.3562 26.718 17.386 26.576 17.3301C26.4377 17.2743 26.3481 17.1366 26.3481 16.9877V13.7196C21.7855 13.8797 17.7461 16.9691 16.4457 21.3427C16.3972 21.5028 16.2514 21.6107 16.087 21.6107C15.9189 21.6107 15.7731 21.5028 15.7283 21.3427C15.4107 20.2782 15.25 19.1764 15.25 18.0709C15.25 11.8957 20.1937 6.84837 26.3481 6.65108V3.3718C26.3481 3.22292 26.4377 3.0852 26.576 3.02936C26.718 2.96981 26.8787 3.0033 26.9833 3.10753L33.8103 9.91548C33.9597 10.0603 33.9597 10.2952 33.814 10.4403Z",
    fill: "#93B5F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShareFlat);
export default __webpack_public_path__ + "static/media/IconShareFlat.b452228fda3436576c3055189d4eb33c.svg";
export { ForwardRef as ReactComponent };